<template>
  <div>
    <md-card>
      <form novalidate class="md-layout-row md-gutter" @submit.prevent="saveUser">
        <md-card-header>
          <div class="md-title">Profile</div>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Name</label>
            <md-input v-model="user.name" :disabled="saving" />
          </md-field>
          <md-field>
            <label>Username</label>
            <md-input v-model="user.username" :disabled="saving" />
          </md-field>
        </md-card-content>
        <md-dialog-actions>
          <md-button class="md-primary" @click="cancelSave">Cancel</md-button>
          <md-button class="md-primary md-raised" v-bind:disabled="!saveActive" type="submit">Save</md-button>
        </md-dialog-actions>
      </form>
    </md-card>

    <md-card>
      <form novalidate class="md-layout-row md-gutter" @submit.prevent="updatePassword">
        <md-card-header>
          <div class="md-title">Password</div>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Current Password</label>
            <md-input v-model="password.current" :disabled="passwordUpdating" type="password"/>
          </md-field>
          <md-field>
            <label>New Password</label>
            <md-input v-model="password.newPassword" :disabled="passwordUpdating" type="password"/>
          </md-field>
          <md-field>
            <label>Password Confirmation</label>
            <md-input v-model="password.confirmation" :disabled="passwordUpdating" type="password"/>
          </md-field>
        </md-card-content>
        <md-dialog-actions>
          <md-button class="md-primary" @click="resetPasswordFields" :disabled="passwordUpdating">Cancel</md-button>
          <md-button class="md-primary md-raised" v-bind:disabled="!passwordSaveActive" type="submit">Save</md-button>
        </md-dialog-actions>
      </form>
    </md-card>

    <br/>
    <md-card>
      <md-card-header>
        <div class="md-title">Recent Logins</div>
      </md-card-header>
      <md-card-content>
        <div v-for="entry in lastSuccessfulLogEntries">{{entry.formattedTimestamp}} - {{entry.remoteIP}}</div>
      </md-card-content>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Recent Failed Login Attempts</div>
      </md-card-header>
      <md-card-content>
        <div v-for="entry in lastFailedLogEntries">{{entry.formattedTimestamp}} - {{entry.remoteIP}}</div>
      </md-card-content>
    </md-card>

    <md-snackbar md-position="center" :md-duration="8000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "user-preferences",
    data () {
      return {
        saving: false,
        passwordUpdating: false,
        user: {
          name: '',
          username: ''
        },
        password: {
          current: '',
          newPassword: '',
          confirmation: ''
        },
        showSnackbar: false,
        snackbarMessage: '',
        lastSuccessfulLogEntries: [],
        lastFailedLogEntries: []
      }
    },
    computed: {
      saveActive() {
        return this.$store.state.session.user.name !== this.user.name || this.$store.state.session.user.username.username !== this.user.username;
      },
      passwordSaveActive() {
        return !this.passwordUpdating && this.password.newPassword === this.password.confirmation && this.password.confirmation.length > 1 && this.password.current.length > 1;
      },
      sessionUser() {
        return this.$store.state.session.user;
      }
    },
    methods: {
      loadUser() {
        this.user = {
          name: this.$store.state.session.user.name,
          username: this.$store.state.session.user.username.username
        };

        this.$store.api.rpcRequest('getLastLoginEntries', {
          success: true
        }, lastLogEntries => {
          lastLogEntries.forEach(entry => {
            entry.formattedTimestamp = moment(entry.timestamp).fromNow();
          });
          this.lastSuccessfulLogEntries = lastLogEntries;
        }, errorMessage => {
          this.passwordUpdating = false;
        });
        this.$store.api.rpcRequest('getLastLoginEntries', {
          success: false
        }, lastLogEntries => {
          lastLogEntries.forEach(entry => {
            entry.formattedTimestamp = moment(entry.timestamp).fromNow();
          });
          this.lastFailedLogEntries = lastLogEntries;
        }, errorMessage => {
          this.passwordUpdating = false;
        });
      },
      saveUser: function () {
        this.saving = true;
        this.user.versionedId = this.$store.state.session.user.versionedId;
        this.$store.api.rpcRequest('saveMyUser', this.user, newUser => {
          this.saving = false;
        }, errorMessage => {
          this.saving = false;
        });
      },
      cancelSave: function () {
        this.loadUser();
      },
      resetPasswordFields() {
        this.password.current = '';
        this.password.newPassword = '';
        this.password.confirmation = '';
      },
      updatePassword() {
        this.passwordUpdating = true;
        this.password.versionedId = this.$store.state.session.user.versionedId;
        this.$store.api.rpcRequest('updateMyPassword', this.password, newUser => {
          this.passwordUpdating = false;
          this.resetPasswordFields();
          this.snackbarMessage = "Password has been updated";
          this.showSnackbar = true;
        }, errorMessage => {
          this.passwordUpdating = false;
        });
      }
    },
    created() {
      this.loadUser();
      this.resetPasswordFields();
    },
    watch: {
      sessionUser() {
        this.loadUser();
      }
    }
  }
</script>

<style scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserPreferences.vue